import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("checking");
  const sid = params.get("session_id");
  const bookingId = params.get("booking_id");
  useEffect(() => {
    // Razorpay flow: booking_id passed, already verified server-side
    if (bookingId && !sid) { setStatus("paid"); return; }
    if (!sid) return setStatus("error");
    let tries = 0;
    const check = async () => {
      tries++;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") setStatus("paid");
        else if (["failed","expired"].includes(data.payment_status)) setStatus("failed");
        else if (tries > 10) setStatus("pending");
        else setTimeout(check, 2000);
      } catch { setStatus("error"); }
    };
    check();
  }, [sid, bookingId]);
  return (
    <div className="pt-32 pb-24 min-h-screen bg-slate-50 dark:bg-slate-950">
      <div className="max-w-lg mx-auto text-center p-10 rounded-3xl bg-white dark:bg-slate-900 shadow-2xl border border-slate-200/70 dark:border-white/10">
        {status === "paid" ? (
          <>
            <div className="mx-auto w-20 h-20 rounded-full bg-emerald-500/10 flex items-center justify-center"><CheckCircle2 className="w-10 h-10 text-emerald-500"/></div>
            <h1 className="mt-6 text-3xl font-bold text-blue-950 dark:text-white">Booking Confirmed!</h1>
            <p className="mt-3 text-slate-600 dark:text-slate-300">Your trip is officially on the calendar. A confirmation email + WhatsApp update is on its way.</p>
          </>
        ) : status === "checking" ? (
          <><div className="animate-pulse text-slate-400 text-4xl">✦</div><p className="mt-4">Verifying payment...</p></>
        ) : (
          <>
            <div className="mx-auto w-20 h-20 rounded-full bg-rose-500/10 flex items-center justify-center"><XCircle className="w-10 h-10 text-rose-500"/></div>
            <h1 className="mt-6 text-3xl font-bold text-blue-950 dark:text-white">Payment pending</h1>
            <p className="mt-3 text-slate-600 dark:text-slate-300">If money was debited, don't worry — we'll confirm within minutes. You can also WhatsApp us.</p>
          </>
        )}
        <button data-testid="ps-home" onClick={()=>nav("/")} className="mt-8 px-6 py-3 rounded-full btn-gold text-sm">Back to home</button>
      </div>
    </div>
  );
}

export function PaymentCancelPage() {
  return (
    <div className="pt-32 pb-24 min-h-screen bg-slate-50 dark:bg-slate-950">
      <div className="max-w-lg mx-auto text-center p-10 rounded-3xl bg-white dark:bg-slate-900 shadow-2xl border border-slate-200/70 dark:border-white/10">
        <div className="mx-auto w-20 h-20 rounded-full bg-amber-500/10 flex items-center justify-center"><XCircle className="w-10 h-10 text-amber-500"/></div>
        <h1 className="mt-6 text-3xl font-bold text-blue-950 dark:text-white">Payment cancelled</h1>
        <p className="mt-3 text-slate-600 dark:text-slate-300">No charges made. Your booking is on hold — resume anytime.</p>
        <Link to="/packages" className="mt-8 inline-block px-6 py-3 rounded-full btn-gold text-sm">Browse packages</Link>
      </div>
    </div>
  );
}
